import constantApi from "../api/constant-api";

const getConstants = async () => {
    const resp = await constantApi.get();
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}


const getUserRole = async () => {
	try {
		const { constants } = await constantApi.get();
		const { userRole } = constants;
		return { userRole };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getUserStatus = async () => {
	try {
		const { constants } = await constantApi.get();
		const { userStatus } = constants;
		return { userStatus };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getTemplateType = async () => {
	try {
		const { constants } = await constantApi.get();
		// console.log(' constants ',constants);
		const { templateType } = constants;
		return { templateType };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getMenuType = async () => {
	try {
		const { constants } = await constantApi.get();
		const { menuType } = constants;
		return { menuType };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const sendEmailResetPassword = async (payload) => {
    const resp = await constantApi.sendEmailResetPassword(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
};

const constantService = {
    getUserStatus,
    getUserRole,
    getConstants,
	getTemplateType,
	getMenuType,
	sendEmailResetPassword
};

export default constantService;